export default {
    OK: "OK",
    ERROR: "ERROR",
    NEW: "NEW",
    SUBMITTED: "SUBMITTED",
    PUBLISHING_ERROR: "PUBLISHING_ERROR",
    DELETED: "DELETED",
    PUBLISHED: "PUBLISHED",
    UNCREATED: "UNCREATED",
    TED_ERROR: "TED_ERROR"
}
